import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { getProductFeature, PRODUCT_FEATURES } from '../data/productFeatures';
import './ProductFeature.css';

export default function ProductFeature() {
  const { slug } = useParams();
  const feature = getProductFeature(slug);

  if (!feature) return <Navigate to="/" replace />;

  const related = PRODUCT_FEATURES.filter(item => item.slug !== slug).slice(0, 3);

  return (
    <div className="pf-page">
      <header className="pf-nav">
        <Link className="pf-logo" to="/">
          <img src="/app-icon.png" alt="" />
          <span>TuWay Africa</span>
        </Link>
        <div className="pf-nav-actions">
          <Link className="pf-link" to="/faq">Help &amp; FAQ</Link>
          <Link className="pf-button pf-button-light" to="/login">Sign in</Link>
          <Link className="pf-button pf-button-dark" to="/register">Get started free</Link>
        </div>
      </header>

      <main>
        <section className="pf-hero">
          <Link className="pf-back" to="/">← Back to homepage</Link>
          <div className="pf-hero-icon" aria-hidden="true">{feature.icon}</div>
          <p className="pf-eyebrow">TuWay Africa feature</p>
          <h1>{feature.title}</h1>
          <p className="pf-intro">{feature.intro}</p>
          <div className="pf-hero-actions">
            <Link className="pf-button pf-button-dark" to="/register">Start for free →</Link>
            <Link className="pf-button pf-button-outline" to="/faq">Read the FAQ</Link>
          </div>
        </section>

        <section className="pf-content">
          <div>
            <p className="pf-eyebrow">What you can do</p>
            <h2>Everything you need from {feature.title}</h2>
            <div className="pf-capabilities">
              {feature.capabilities.map(capability => (
                <div className="pf-capability" key={capability}>
                  <span aria-hidden="true">✓</span>
                  <p>{capability}</p>
                </div>
              ))}
            </div>
          </div>
          <aside className="pf-benefit">
            <span aria-hidden="true">✦</span>
            <p className="pf-eyebrow">Why it matters</p>
            <h2>Work smarter with every customer</h2>
            <p>{feature.benefit}</p>
          </aside>
        </section>

        <section className="pf-related">
          <p className="pf-eyebrow">Explore more</p>
          <h2>Features that work well together</h2>
          <div className="pf-related-grid">
            {related.map(item => (
              <Link to={`/products/${item.slug}`} key={item.slug}>
                <span aria-hidden="true">{item.icon}</span>
                <strong>{item.title}</strong>
                <small>{item.navDesc}</small>
              </Link>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
